import {useListView} from '../core/ListViewProvider'
import {OptionListToolbar} from './OptionListToolbar'
import {OptionListGrouping} from './OptionListGrouping'
import {OptionListSearchComponent} from './OptionListSearchComponent'

const OptionListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <OptionListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <OptionListGrouping /> : <OptionListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {OptionListHeader}
